export const NORWEGIAN_MOBILE_NUMBER_PATTERN = /^([4,9,6,7](\d{7}|\d{6})|5\d{11})$/
export const SWEDISH_MOBILE_NUMBER_PATTERN = /^(0?7([0-3,6,9])-?(\d{11}|\d{7}))$/
export const SWEDISH_MOBILE_NUMBER_PATTERN_NO_DASH = /^(0?7([0-3,6,9])(\d{11}|\d{7}))$/

export const EMAIL_PATTERN =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const getNormalizedPhoneNumber = (phoneNumber: string) => {
  if (phoneNumber.match(SWEDISH_MOBILE_NUMBER_PATTERN_NO_DASH)) {
    return phoneNumber.substring(0, 3) + '-' + phoneNumber.substring(3, phoneNumber.length)
  }
  return phoneNumber
}
